export default __webpack_public_path__ + "static/media/ico-Aon.00397a87.svg";